import ProductDescription from './ProductDescription'

const BSWholeWheatBagelsProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '010BS',
  IsBroadband: true,
  Size: '',
}

export default BSWholeWheatBagelsProduct
